export const SET_SONGS = 'SET_SONGS';
export const SET_SONG_INDEX = 'SET_SONG_INDEX';
export const SET_PLAYING = 'SET_PLAYING';
export const SET_LOADING = 'SET_LOADING';
export const SET_DURATION = 'SET_DURATION';
export const SET_TIME = 'SET_TIME';
export const SET_ERROR = 'SET_ERROR';
